import { CatalogData } from "../../data/catalogData";
import { ContractsTypes } from "../../data/enums/contractsTypes";

/** Набор параметров для запросов выписок и истории операций */
export class RequestParamsModel {
  /** Колличество записей */
  public take: number = 1000;

  /** Колличество пропусков записей */
  public skip: number = 0;

  /** Дата начала */
  public dateBegin: string = "";

  /** Дата конца */
  public dateEnd: string = "";

  /** Номер счета  */
  public contractId: number = 0;

  /** Тип каталога */
  public catalogType: number = 0;

  public rootCatalog: CatalogData = new CatalogData();

  public filter: number = 0;

  /** строка поиска */
  public searchText: string = "";

  public sortType: number = 1;

  public contractType: ContractsTypes = ContractsTypes.None;

  constructor(src: any) {
    this.take = src.take ?? 1000;
    this.skip = src.skip ?? 0;
    this.dateBegin = src.dateBegin ?? "";
    this.dateEnd = src.dateEnd ?? "";
    this.contractId = src.contractId ?? 0;
    this.catalogType = src.catalogType ?? 0;
    this.filter = src.filter ?? 0;
    this.searchText = src.searchText ?? "";
    this.sortType = src.sortType ?? 0;
    this.rootCatalog = src.rootCatalog ?? new CatalogData();
    this.contractType = (src.contractType as ContractsTypes) ?? ContractsTypes.None;
  }
}
